import Paper from '@mui/material/Paper';
import { styled } from '@mui/system';

export const Wrapper = styled(Paper)(() => ({
	background: 'rgba(255, 255, 255, 0.3)',
	boxShadow: '7px 4px 30px 0px rgba(130, 125, 131, 0.15)',
	backdropFilter: 'blur(10px)',

	display: 'flex',
	flexDirection: 'column',

	padding: '16px 8px 8px 8px',
	borderRadius: '20px',
	margin: '0px 8px 8px 8px',
}));

export const StyledPageContentWrapper = styled(Paper)(() => ({
	maxWidth: 'min(95%,920px)',
	backdropFilter: 'blur(10px)',
	width: '100%',
	justifySelf: 'center',
	display: 'flex',
	flexDirection: 'column',
	padding: '16px 8px 8px 8px',
	borderRadius: '16px',
	margin: '0px 8px 16px 8px',
}));

export const Header = styled('div')({
	marginBottom: '16px',
});

export const Body = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
});

export const HeaderTopWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	position: 'relative',
	flexWrap: 'wrap',
	gap: '8px',
});
